<template>
    <div class="buy-tokens-wrap" @click.self="closeBuyTokens">
        <div class="buy-tokens--inner">
            <div class="close-buyer" @click="closeBuyTokens">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-x" viewBox="0 0 16 16">
                    <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"/>
                </svg>
            </div>
            <!-- <h4>How many tokens you want?</h4> -->

            <div class="class-pricing-cards">
                <div v-for="pricing in pricings" class="pricing-card">
                    <div v-if="pricing.name > 1" class="savings-tag" :class="pricing.name === 10 ? 'savings-tag-10':'savings-tag-25'">
                        <span>ahorra</span> <span>€{{ pricing.savings }}</span>
                    </div>
                    <h5>{{ pricing.name }} <span v-if="pricing.name === 1">Ficha</span><span v-else>Fichas</span></h5>
                    <!-- <p class="pricing">€{{ pricing.price * pricing.name - ( pricing.price * pricing.name * promoToApply/100.00) }}</p> -->
                    <p class="pricing">€{{ (pricing.price * pricing.name - (pricing.price * pricing.name * promoToApply / 100.00)).toFixed(2) }}</p>

                    <p>Válido para {{ pricing.name }} <span v-if="pricing.name === 1">carta.</span><span v-else>cartas.</span></p>
                    <button v-if="this.$store.state.loggedIn" class="button2 buttonNoCaps" @click="goToPaypal(pricing.name, pricing.price, 'card')">Pago con Tarjeta</button><br>
                    <button v-if="this.$store.state.loggedIn" class="button2 buttonNoCaps bizumButton" @click="goToPaypal(pricing.name, pricing.price, 'bizum')">
                        <svg width="122" height="36" viewBox="0 0 122 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M59.8625 12.8257C58.8278 12.8257 57.9921 13.6615 57.9921 14.6565V28.4678C57.9921 29.5026 58.8278 30.3385 59.8625 30.3385C60.8972 30.3385 61.7329 29.5026 61.7329 28.4678V14.6565C61.7329 13.6615 60.8972 12.8257 59.8625 12.8257ZM59.8624 5.94009C58.7084 5.94009 57.7533 6.89533 57.7533 8.04959C57.7533 9.20384 58.7084 10.1989 59.8624 10.1989C61.0165 10.1989 61.9716 9.24364 61.9716 8.04959C61.9716 6.89533 61.0165 5.94009 59.8624 5.94009ZM78.089 14.6566C78.089 13.5023 77.1737 13.0645 76.338 13.0645H67.0655C66.1502 13.0645 65.4339 13.7809 65.4339 14.6566C65.4339 15.572 66.1502 16.2885 67.0655 16.2885H73.1543L65.2747 27.2738C65.0359 27.5922 64.9166 28.03 64.9166 28.3882C64.9166 29.5425 65.8319 30.1793 66.6278 30.1793H76.4574C77.3727 30.1793 78.089 29.4629 78.089 28.5474C78.089 27.632 77.3727 26.9156 76.4574 26.9156H69.8512L77.5716 16.169C77.9696 15.6118 78.089 15.1342 78.089 14.6566ZM50.789 23.3335C50.789 25.6022 49.7941 26.9953 47.5257 26.9953C45.2574 26.9953 44.3023 25.6022 44.3023 23.3335V16.2885H47.6849C50.4308 16.2885 50.789 17.801 50.789 19.4727V23.3335ZM54.5298 19.3931C54.5298 15.5323 52.5002 13.0248 47.7645 13.0248H44.3421V7.81078C44.3421 6.77593 43.5064 5.94009 42.5115 5.94009C41.4768 5.94009 40.6411 6.77593 40.6411 7.81078V23.3335C40.6411 27.1943 42.7104 30.3386 47.6053 30.3386C52.4604 30.3386 54.5696 27.1545 54.5696 23.3335V19.4727V19.3931H54.5298ZM92.694 12.8257C91.6594 12.8257 90.8236 13.6615 90.8236 14.6963V23.3334C90.8236 25.6021 89.8287 26.9951 87.5604 26.9951C85.292 26.9951 84.3369 25.6021 84.3369 23.3334V14.6963C84.3369 13.6615 83.5012 12.8257 82.5063 12.8257C81.4716 12.8257 80.6359 13.6615 80.6359 14.6963V23.3334C80.6359 27.1941 82.7053 30.3385 87.6002 30.3385C92.4553 30.3385 94.5644 27.1543 94.5644 23.3334V14.6963C94.5247 13.6615 93.6889 12.8257 92.694 12.8257ZM121.068 19.8708C121.068 16.01 119.278 12.8656 114.423 12.8656C112.234 12.8656 110.682 13.5025 109.607 14.5771C108.533 13.5423 106.981 12.8656 104.792 12.8656C99.9368 12.8656 98.146 16.0498 98.146 19.8708V28.5078C98.146 29.5426 98.9817 30.3785 99.9766 30.3785C101.011 30.3785 101.847 29.5426 101.847 28.5078V19.8708C101.847 17.6021 102.563 16.209 104.792 16.209C107.06 16.209 107.737 17.6021 107.737 19.8708V28.5078C107.737 29.5426 108.573 30.3785 109.567 30.3785C110.602 30.3785 111.438 29.5426 111.438 28.5078V19.8708C111.438 17.6021 112.154 16.209 114.383 16.209C116.651 16.209 117.328 17.6021 117.328 19.8708V28.5078C117.328 29.5426 118.163 30.3785 119.158 30.3785C120.193 30.3785 121.029 29.5426 121.029 28.5078L121.068 19.8708ZM6.61567 12.8655C7.92894 13.8208 9.75954 13.5422 10.7146 12.2287L14.1371 7.49227C15.0922 6.17881 14.8136 4.34793 13.5004 3.39268C12.1871 2.43744 10.3565 2.71605 9.40138 4.02951L5.93914 8.76593C5.02384 10.0794 5.30241 11.9103 6.61567 12.8655ZM22.2952 6.17881C20.9819 5.22357 19.1513 5.50218 18.1962 6.81564L4.42685 25.7613C3.47175 27.0748 3.75032 28.9057 5.06358 29.8609C6.37684 30.8162 8.20745 30.5376 9.16255 29.2241L22.9319 10.2784C23.9268 8.96495 23.6084 7.13406 22.2952 6.17881ZM5.3024 4.66637C6.2575 3.35291 5.97892 1.52202 4.66566 0.566779C3.3524 -0.388466 1.52179 -0.109853 0.566693 1.20361C-0.388407 2.51707 -0.109836 4.34796 1.20343 5.3032C2.51669 6.25845 4.3473 5.97983 5.3024 4.66637ZM26.1952 30.6968C24.882 29.7415 23.0514 30.0202 22.0963 31.3336C21.1412 32.6471 21.4197 34.478 22.733 35.4332C24.0463 36.3885 25.8769 36.1098 26.832 34.7964C27.7871 33.4829 27.5085 31.652 26.1952 30.6968ZM20.8228 23.1742C19.5096 22.219 17.679 22.4976 16.7239 23.8111L13.2616 28.5475C12.3065 29.8609 12.5851 31.6918 13.8983 32.6471C15.2116 33.6023 17.0422 33.3237 17.9973 32.0102L21.4596 27.2738C22.4147 25.9604 22.1361 24.1295 20.8228 23.1742Z" fill="#006aff"></path>
                            </svg>
                    </button>                    
                    <button v-if="!this.$store.state.loggedIn" @click="launchLoginModal">Crear cuenta</button>
                    <p class="savings-on-price" v-if="pricing.savings">
                        Ahorras €{{ pricing.savings }} en tu compra.
                    </p>
                </div>
            </div>
            <p class="instructions-pricing">Nuestros precios incluyen IVA. / Las fichas no tienen caducidad.</p>
            <div v-if="makeVisibleCoupons && this.$store.state.loggedIn">
                <div><a class="small_link" href="#" @click.prevent="showCouponField = true">¿Tienes un código promocional?</a></div>
                <div v-if="showCouponField">
                    <input type="text" placeholder="código promocional" v-model="promoCodeInput" @focus="promoCodeNotExisten = false"><br>
                    <button class="button1" @click="validatePromoCode">validar</button>
                </div>
                <div class="promocodeerror" v-if="promoCodeNotExisten">Código inválido.</div>
                <div class="promocodesuccess" v-if="showSuccessMessagePromo">Exito. Descuento aplicado.</div>
            </div>

        </div>
    </div>
</template>

<script>
import axios from 'axios';
export default {
    data() {
        return {
            showSuccessMessagePromo: false,
            promoCodeNotExisten: false,
            makeVisibleCoupons: true,
            promoCodeInput: '',
            showCouponField: false,
            promoCodesArray: [
                {
                    code: 'navarro25',
                    discount: 25
                },
                {
                    code: 'carta10',
                    discount: 10
                },
                {
                    code: 'EURO24',
                    discount: 50
                }
            ],
            promoToApply: 0,
            promoCodeName: null,
            tokens: 1,
            tokenPrice: 2,
            pricings: [
                {   
                    name: 1,
                    price: 3,
                    savings: null
                },
                {   
                    name: 10,
                    price: 2.5,
                    savings: 5
                },
                {   
                    name: 25,
                    price: 2,
                    savings: 25
                }
            ]
        }
    },
    methods: {
        validatePromoCode() {

            this.promoCodeNotExisten = false;
            const foundPromoCode = this.promoCodesArray.find(promoCode => promoCode.code === this.promoCodeInput);

            if (foundPromoCode) {
                console.log(`Valid promo code with a discount of ${foundPromoCode.discount}%`);
                this.promoToApply = foundPromoCode.discount
                this.promoCodeName = foundPromoCode.code;
                this.showSuccessMessagePromo = true;
                let vm = this;
                setTimeout(()=>{
                    vm.showSuccessMessagePromo = false;
                    vm.makeVisibleCoupons = false;
                }, 1500);
                
            } else {
                this.promoCodeNotExisten = true;
            }

           
        },
        closeBuyTokens() {
            this.$emit('closeBuyTokens');
        },
        async goToPaypal (amount,price,paymentMethod) {

            this.$emit('addToSessionStorage');

            const formData = new FormData();

            if(this.promoCodeName) {
                formData.append('couponCode', this.promoCodeName);
            }

            formData.append('tokensNeeded', amount);
            formData.append('paymentMethod', paymentMethod);

            console.log(formData)

            const response = await axios.post(
                'https://www.cartafutbol.com/api/v1/Invoice/saveInvoice_Test.php',
                formData,
                {headers: {
                    'Authorization': `Bearer ${this.$store.state.user.tokenId}`
                }},
            );

            if (JSON.parse(response.data.success)) {
                console.log(response.data);
                window.open(response.data.invoicePaypalUrl, "_self");
            }else {
            //     // Handle failure: User registration failed
                console.warn('Redirection PayPal failed:', response.data.message);

            }

            


            
        },
        launchLoginModal() {
            this.$emit('closeBuyTokens');
            this.$emit('openLoginWindow');
        }
    },
    computed: {
       
    }
}
</script>

<style lang="less">

.buy-tokens-wrap {
    position: fixed;
    top: 0;
    left: 0;
    height: 100vh;
    width: 100vw;
    background: var(--overlay_bg);
    display: flex;
    align-items: center;
    justify-content: flex-start;
    padding: 1rem;
    z-index: 1000;
    overflow: auto;
}

.buy-tokens--inner {
    background: white;
    padding: 3rem 2rem 3rem;
    width: 100%;
    max-width: 850px;
    border-radius: var(--radius_global);
    box-shadow: var(--modal_boxshadow);
    margin: auto;
    position: relative;

    button {
        margin: 2rem 0;
    }
}

.buy-input {
    display: flex;
    align-items: center;

    span {
        margin: 0.5rem;
    }

    input {
        height: 40px;
        width: 60px;
    }

    
}

.close-buyer {
    position: absolute;
    top: 1rem;
    right: 1rem;
    cursor: pointer;

    svg {
        width: 2rem;
        height: auto;
    }
}

.class-pricing-cards {
    display: flex;
    flex-wrap: wrap;
    gap: 1.5rem;
}

.pricing-card {
    flex: 1;
    border-radius: var(--radius_global);
    box-shadow: var(--cards-boxshadow);
    padding: 2rem 1rem;
    text-align: center;
    position: relative;

    p.pricing {
        font-weight: 400;
        color: var(--blue_main);
        font-size: 1.75rem;
        margin-bottom: 1rem;
        font-family: var(--comic-font);
    }

    h5 {
        font-weight: 400;
        font-size: 1.5rem;
        padding: 0 0 1rem;
        margin-bottom: 1.75rem;
        position: relative;
        font-family: var(--comic-font);

        &::after {
            content: '';
            background: linear-gradient( 90deg, #f1f1f1 30%, transparent 30%, transparent 75%, #f1f1f1 75% );
            width: 100%;
            height: 0.75rem;
            background-size: 0.5rem;
            transform: skew(-30deg,0);
            background-position-x: right;
            display: block;
            position: absolute;
            left: 0;
            top: 100%;
        }
    }
}

.savings-on-price {
    font-weight: 600;
    font-size: 0.75rem;
}

.savings-tag {
    position: absolute;
    top: -0.5rem;
    right: 1rem;
    padding: 0.2rem 0.5rem;
    font-size: 0.65rem;
    text-transform: uppercase;
    display: flex;
    flex-direction: column;
    color: #fff;
    border-radius: var(--radius_global);
    font-weight: 700;
    line-height: 1;
}

.savings-tag-10 {
    background: var(--green_main);
}

.savings-tag-25 {
    background: var(--orange_main);
}

.instructions-pricing {
    margin: 2rem 0 0rem;
    font-weight: 600;
    font-size: 0.85rem;
}

@media(max-width:768px) {
    .pricing-card {
        width: 100%;
        flex: none;
        gap: 0;
        margin-bottom: 1.5 rem;
    }
}

a.small_link {
    font-size: 0.85rem;
    font-weight: 700;
    display: inline-block;
    margin: 1rem 0;

    &:hover {
        text-decoration: underline;
    }
}

.promocodeerror {
    font-size: 0.85rem;
    font-weight: 700;
    color: red;
}

.promocodesuccess {
    font-size: 0.85rem;
    font-weight: 700;
    color: var(--green_main);  
}

.pricing-card button:first-of-type {
    margin-bottom: 0!important;
}

.pricing-card button:nth-of-type(2) {
    margin-top: 1rem!important;
}

button.buttonNoCaps {
    text-transform: none!important;
}

button.bizumButton {

    svg{
        display: block;
        height: 1rem;
        width: auto;
    } 
}

</style>